<script lang="ts">
  interface Props {
    currency: string;
  }

  let { currency }: Props = $props();
</script>

<span>
  {#if currency === 'EUR'}
    €
  {:else if currency === 'USD'}
    $
  {:else if currency === 'GBP'}
    £
  {/if}
</span>
